import React from 'react';
import Profile from './Profile';
import { findTime } from '../../../../utils/helper';
import { SlCalender } from "react-icons/sl";

export default function FeedPage({ userData, feedData, handleBackBtn }) {
    return (<div className='inline-flex justify-between gap-2 w-[100%]'>
        <Profile user={userData} backBtn={handleBackBtn} />
        <div className="rounded-lg border-b border-gray-200 bg-white px-4 py-5 sm:px-6 w-[100%]">
      <h3 className="text-base font-bold leading-6 text-gray-900 mb-[0.5em]">Activity Feed</h3>
            <ul role="list" className="divide-y divide-gray-100">
                {feedData.map((item, index) => (<>
                   
                    <div className="min-w-0 inline-flex gap-2 self-end mt-[0.3em]">

                    <SlCalender className=' mt-[0.1em]' />
                        <p className="text-md uppercase font-semibold text-gray-900">
                            {item.date}
                        </p>
                    </div>
                    {item.events.map((clickEvents) => (<>
                        <li key={index} className="flex justify-between gap-x-6 py-5">
                            <div className="flex min-w-0 gap-x-4">
                                <div className="min-w-0 flex-auto">
                                    <p className="text-sm font-semibold leading-6 text-gray-900">{clickEvents.eventName}</p>
                                    <div className="mt-1 flex items-center gap-x-2 text-xs leading-5 text-gray-500">
                                        <p className="whitespace-nowrap">
                                            <time dateTime={clickEvents.eventClickTime}>{findTime(clickEvents.eventClickTime)}</time>
                                        </p>
                                        <svg viewBox="0 0 2 2" className="h-0.5 w-0.5 fill-current">
                                            <circle r={1} cx={1} cy={1} />
                                        </svg>
                                        <p className="truncate">{clickEvents.eventClickDay}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="hidden shrink-0 sm:flex sm:flex-col sm:items-end">
                                <p className="mt-1 text-xs leading-5 text-gray-500">
                                    {clickEvents.eventCategory}
                                </p>

                            </div>
                        </li>
                    </>))
                    }
                </>
                ))}
            </ul>

        </div>
    </div>
    )
};
